import { format, parseISO } from 'date-fns'

import {
  EMPTY_OBJECT,
  EMPTY_STRING,
  SYMBOL_HYPHEN,
} from '../../../../../constants/common'
import { CURRENCY_SYMBOL_MAP } from '../../../../../constants/currency'
import {
  DATE_FULL_FORMAT,
  DATE_SHORT_FORMAT,
} from '../../../../../constants/date'
import { RENTAL_PORTAL_LISTING_STATUSES } from '../../../../../constants/rentalPortal'
import { toUkTimezoneDate } from '../../../../../utils/date'
import { formatNumberWithSeparators } from '../../../../../utils/number'
import { getEntityProfileTabUpdateOwner } from '../../../../Entity'
import { getListingUnitLabel } from '../../../../RentalPortalListing'

import {
  LISTING_UPDATE_ACTION,
  LISTING_UPDATE_ACTION_TRANSLATION_KEY,
} from './RentalPortalListingProfileUpdates.constants'

function getListingUpdateMoneyLabel({ amount, currency }) {
  return amount == null
    ? SYMBOL_HYPHEN
    : `${formatNumberWithSeparators(amount)} ${CURRENCY_SYMBOL_MAP[currency] ?? currency}`
}

function getListingUpdateStatusLabel(status, t) {
  return RENTAL_PORTAL_LISTING_STATUSES[status]
    ? t(RENTAL_PORTAL_LISTING_STATUSES[status].text)
    : EMPTY_STRING
}

function getListingUpdateDateLabel(value) {
  return value ? format(parseISO(value), DATE_SHORT_FORMAT) : SYMBOL_HYPHEN
}

function getListingUpdateDateTimeLabel({ timezone, value }) {
  return value
    ? format(toUkTimezoneDate(parseISO(value), timezone), DATE_FULL_FORMAT)
    : EMPTY_STRING
}

function getListingUpdateValues({ item, listing, t, timezone }) {
  const data = item?.data || EMPTY_OBJECT

  switch (item?.action) {
    case LISTING_UPDATE_ACTION.create:
      return { unit: getListingUnitLabel({ listing, t }) }
    case LISTING_UPDATE_ACTION.updateRentPrice:
      return {
        curr: getListingUpdateMoneyLabel({
          amount: data.new_value,
          currency: data.currency,
        }),
        prev: getListingUpdateMoneyLabel({
          amount: data.old_value,
          currency: data.currency,
        }),
      }
    case LISTING_UPDATE_ACTION.updateAvailableFrom:
      return { curr: getListingUpdateDateLabel(data.new_value) }
    case LISTING_UPDATE_ACTION.updateStatus:
      return {
        curr: getListingUpdateStatusLabel(data.new_value, t),
        prev: getListingUpdateStatusLabel(data.old_value, t),
      }
    case LISTING_UPDATE_ACTION.updatePhotos:
      return { count: data.count ?? 0 }
    case LISTING_UPDATE_ACTION.updateResponsibleManager:
      return {
        curr: data.new_value ?? SYMBOL_HYPHEN,
        prev: data.old_value ?? SYMBOL_HYPHEN,
      }
    case LISTING_UPDATE_ACTION.addApplicant:
      return { source: data.source ?? EMPTY_STRING }
    case LISTING_UPDATE_ACTION.bookViewing:
      return {
        datetime: getListingUpdateDateTimeLabel({
          timezone,
          value: data.starts_at,
        }),
      }
    default:
      return EMPTY_OBJECT
  }
}

export function getListingUpdateText({ item, listing, t, timezone }) {
  const translationKey = LISTING_UPDATE_ACTION_TRANSLATION_KEY[item?.action]

  return translationKey
    ? t(translationKey, getListingUpdateValues({ item, listing, t, timezone }))
    : EMPTY_STRING
}

export function toTranslatedListingUpdates({ items, listing, t, timezone }) {
  return items.map(item => ({
    ...item,
    owner_obj: getEntityProfileTabUpdateOwner(item.initiated_by),
    text: getListingUpdateText({ item, listing, t, timezone }),
    timestamp: item.event_dt,
  }))
}
